import * as React from 'react'
import { FunctionComponent, PropsWithChildren } from 'react'
import { mergeStyles, Spinner, SpinnerSize, Stack, StackItem } from '@fluentui/react'

type Props = PropsWithChildren<{ isLoading: boolean }>

const wrapClassName = mergeStyles({ flexGrow: 1, minWidth: 0, overflow: 'hidden' })

const LoadableText: FunctionComponent<Props> = props => {
    return (
        <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 's1' }}>
            <StackItem className={wrapClassName}>{props.children}</StackItem>
            {props.isLoading && (
                <StackItem>
                    <Spinner size={SpinnerSize.xSmall} />
                </StackItem>
            )}
        </Stack>
    )
}

export default LoadableText
